import { render, staticRenderFns } from "./CmgNutritionCalculatorMealBuilderMobileGraphFooter.vue?vue&type=template&id=408db95f&scoped=true&lang=pug&"
import script from "./cmg-nutrition-calculator-meal-builder-mobile-graph-footer.ts?vue&type=script&lang=ts&"
export * from "./cmg-nutrition-calculator-meal-builder-mobile-graph-footer.ts?vue&type=script&lang=ts&"
import style0 from "./CmgNutritionCalculatorMealBuilderMobileGraphFooter.vue?vue&type=style&index=0&id=408db95f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408db95f",
  null
  
)

export default component.exports